export default __webpack_public_path__ + "static/media/01.c010344b.svg";